<template>
  <table 
    class="menu-item"
    :style="{ 
      '--height': height,
    }"
  >
    <tr style="height:100%">
      <td>
        <div
          class="btn-menu-item"
          v-bind:class="{ active: data.ID === seletedMenuID }"
          @click="handleClick(data)"
        >
          <center>{{ getTranslation(data.Name)}}</center>
        </div>
        <div v-if="data.IsMenuWithSubmenu && (data.ID === seletedMenuID || data.ID === selectedParentID)">
          <div
            class="btn-submenu-item"  
            v-for="(item, index) in data.Menus"
            :key="index"    
            :style="{ 'border-top': index === 0 ? '0px' : 'auto' }"
            v-bind:class="{ active: item.ID === seletedMenuID }"
            @click="handleClick(item)"
          >
            <center>{{ getTranslation(item.Name) }}</center>
          </div>
        </div>
        <div v-else>
          <div
            class="btn-shadow"
          >            
          </div>
        </div>
      </td>
    </tr>
  </table>
</template>

<script>
import {
  mapState
} from 'vuex'
import i18n from '@/plugins/i18n'
import utils from '@/services/utils'
export default {
  props: {
    index: {
      type: Number,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    seletedMenuID: null,
    selectedParentID: null
  }),
  computed: {
    ...mapState('app',['totemMenuSelected']),
    height() {
      return '50px'
    },
    locale () {
      return i18n.locale
    }
  },
  watch: {
    totemMenuSelected: {
      handler: function (newValue) {
        this.seletedMenuID = newValue.ID
        this.selectedParentID = newValue.ParentID
      },
      deep: true
    },
  },
  methods: {
    getTranslation(value) {
      // const aux = JSON.parse(value)
      return utils.getTranslation(value, this.locale)
    },
    handleClick(value) {
      this.$store.state.app.totemMenuSelected = value
    }
  }
}
</script>

<style>
  .menu-item {
    width: 100%;
    height: var(--height);
  }
  .btn-menu-item {
    cursor: pointer;
    /* background: -prefix-linear-gradient(left, #00000069, transparent);
    background: linear-gradient(to right, #00000069, transparent); */
    background: linear-gradient(90deg, rgba(0,0,0,.3), transparent);

    color: white;
    width: 90%;
    margin-left: 10%;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 5px 0 0 5px;
    border: 1px solid rgba(255,255,255,.6);
    border-right: 0px;
    font-weight: 400;
  }
  .btn-menu-item.active {
    color: black !important;
    background: white !important;
  }
  .btn-submenu-item {
    cursor: pointer;
    background-color: #00000069;
    color: white;
    width: 85%;
    margin-left: 15%;
    padding-top: 10px;
    padding-bottom: 10px;
    border: 1px solid white;
    border-right: 0px;
    border-bottom: 0px;
    font-weight: 700;
    min-height: 50px;
  }
  .btn-submenu-item.active {
    color: black !important;
    background: white !important;
  }
  .btn-shadow {
    background-color: rgba(0,0,0,.2);
    height: 5px;
    width: 90%;
    margin-left: 13%;
    border-radius: 0 0 0 3px;
    mix-blend-mode: multiply;
  }
</style>
